import Service from "./apiService";

class ParamsService extends Service {
  getData() {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `params`,
      method: "GET",
    });
  }

  get(code) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `params/${code}`,
      method: "GET",
    });
  }  

  add(form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `params`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  update(code, form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `params/${code}`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  delete(code) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `params/${code}`,
      method: "DELETE",
    });
  }
}

export var paramsService = new ParamsService();
